// Thin typed-ish wrapper around the REST API. All components talk to the backend
// through this module so the base URL / error handling lives in one place.
const BASE = (import.meta.env.VITE_API_BASE_URL || "/api").replace(/\/$/, "");

export class ApiError extends Error {
  constructor(message, status, body) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
  }
}

async function request(path, { method = "GET", body, signal } = {}) {
  let res;
  try {
    res = await fetch(BASE + path, {
      method,
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
      signal,
    });
  } catch (cause) {
    throw new ApiError("Network request failed", 0, { cause });
  }
  const type = res.headers.get("content-type") || "";
  const data = type.includes("application/json") ? await res.json().catch(() => null) : await res.text();
  if (!res.ok) {
    const message = (data && data.error && data.error.message) || res.statusText || "Request failed";
    throw new ApiError(message, res.status, data);
  }
  return data;
}

export const api = {
  base: BASE,
  health: (opts) => request("/health", opts),
  getContent: (lang, opts) => request("/content?lang=" + encodeURIComponent(lang || "id"), opts),
  getBookingSlots: (opts) => request("/booking-slots", opts),
  createBooking: (payload) => request("/bookings", { method: "POST", body: payload }),
  createLead: (payload) => request("/leads", { method: "POST", body: payload }),
  subscribe: (payload) => request("/subscribers", { method: "POST", body: payload }),
};
